import { render, staticRenderFns } from "./mobile-productDescription.vue?vue&type=template&id=34d9c475&scoped=true&"
import script from "./mobile-productDescription.vue?vue&type=script&lang=js&"
export * from "./mobile-productDescription.vue?vue&type=script&lang=js&"
import style0 from "./mobile-productDescription.vue?vue&type=style&index=0&id=34d9c475&prod&scoped=true&lang=css&"
import style1 from "./mobile-productDescription.vue?vue&type=style&index=1&id=34d9c475&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d9c475",
  null
  
)

export default component.exports